module.exports = ".btn-margin {\r\n    margin-top: 10px;\r\n}\r\n\r\n/* tr.bottom-pad td {\r\n    padding-bottom:26px;\r\n} */\r\n\r\n.table th {\r\n    border-top: 0px solid #eceeef;\r\n}\r\n\r\n.margin-top{\r\n    margin-top: 10px;\r\n}\r\n\r\n.tspan{\r\n    color: #333333;\r\n    font-size: 18px;\r\n    fill: #333333;\r\n    font-weight: 500;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/notification/notification.component.css
// module id = ./src/app/modules/dashboard/notification/notification.component.css
// module chunks = main